export enum TkColor {
  Primary = '#061178',
  PrimaryBg = '#adc6ff',

  Secondary = '#00474f',
  SecondaryBg = '#87e8de',

  Tertiary = '#22075e',
  TertiaryBg = '#d3adf7',

  Success = '#135200',
  SuccessBg = '#b7eb8f',

  Warning = '#876800',
  WarningBg = '#fadb14',

  Danger = '#820014',
  DangerBg = '#ffa39e',

  Light = '#f0f0f0',
  LightBg = '#000000',

  Medium = '#5f5f5f',
  MediumBg = '#ffffff',

  Dark = '#2f2f2f',
  DarkBg = '#ffffff',

  WoundManagement = '#0d0225',
  WoundManagementBg = '#efdbff',

  CarePlan = '#270006',
  CarePlanBg = '#ffccc7',

  Rai = '#001138',
  RaiBg = '#bae0ff',

  TimeTracking = '#0c1400',
  TimeTrackingBg = '#f4ffb8',

  EmployeesRoster = '#33001f',
  EmployeesRosterBg = '#e0ccd8',

  OperatingPlan = '#00474f',
  OperatingPlanBg = '#b5f5ec',

  Info = '#00474f',
  InfoBg = '#b5f5ec',

  CustomerDocuments = '#38402c',
  CustomerDocumentsBg = '#C7D89B',

  EmployeeDocuments = '#38402c',
  EmployeeDocumentsBg = '#C7D89B',

  Instructions = '#1e1b00',
  InstructionsBg = '#e0decc',

  IdentityCard = '#272631',
  IdentityCardBg = '#dcdaf9',

  ProductManagement = '#2b251f',
  ProductManagementBg = '#fbdbb7',

  VitalSigns = '#0c1400',
  VitalSignsBg = '#f4ffb8',

  ProcessReports = '#0c1400',
  ProcessReportsBg = '#FFE5B4',
}
